<template>

    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
        <defs>
            <clipPath id="clip-PDF_Light">
                <rect width="48" height="48"/>
            </clipPath>
        </defs>
        <g id="PDF_Light" clip-path="url(#clip-PDF_Light)">
            <g id="Group_39118" data-name="Group 39118" transform="translate(-6783 6075)">
                <circle id="Ellipse_1069" data-name="Ellipse 1069" cx="24" cy="24" r="24" transform="translate(6783 -6075)" class="svg-primary-color"/>
                <path id="Path_4413" class="svg-on-primary-color" data-name="Path 4413" d="M-84.342-28.122v5h-3l5,6,5-6h-3v-5Zm11-16h3l-6-6v3A3,3,0,0,0-73.341-44.122Zm-4-3v-3h-13a4,4,0,0,0-4,4v22a4,4,0,0,0,4,4h4.2l-.834-1h-3.364a3,3,0,0,1-3-3v-5h22v5a3,3,0,0,1-3,3h-3.365l-.834,1h4.2a4,4,0,0,0,4-4v-19h-3A4,4,0,0,1-77.341-47.122Z" transform="translate(6889.341 -6015.878)" />
                <path id="Path_4385" class="svg-primary-color" data-name="Path 4385" d="M-89.77-34.7v2.578H-91.2v-7.109h2.832a2.8,2.8,0,0,1,1.929.625,2.1,2.1,0,0,1,.7,1.646,2.087,2.087,0,0,1-.7,1.641,2.816,2.816,0,0,1-1.929.62Zm0-1.1h1.406a1.185,1.185,0,0,0,.9-.322,1.156,1.156,0,0,0,.308-.828,1.215,1.215,0,0,0-.305-.847,1.166,1.166,0,0,0-.906-.334H-89.77Zm5.188,3.678v-7.109h2.441a2.935,2.935,0,0,1,2.148.833,2.872,2.872,0,0,1,.845,2.136v1.177a2.862,2.862,0,0,1-.844,2.135,2.944,2.944,0,0,1-2.149.828Zm1.426-6.011v4.911h.942a1.483,1.483,0,0,0,1.2-.517,2.035,2.035,0,0,0,.435-1.351v-1.184a2.02,2.02,0,0,0-.435-1.341,1.486,1.486,0,0,0-1.2-.517Zm9.631,3.057H-76.5v2.954h-1.425v-7.109h4.9v1.1H-76.5v1.958h2.979Z" transform="translate(6889.341 -6015.878)"/>
            </g>
        </g>
    </svg>

</template>

<script>

export default {
        name: "pdfIcon",
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/pdfIcon.vue